module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.0.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP1"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP2"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 1",
      "src": "data/content-0002.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0.2"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PA1"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 2",
      "src": "data/content-0003.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PA3"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 4",
      "src": "data/content-0004.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0.2"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PA4"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.2.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 5",
      "src": "data/content-0005.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.2.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.6.0.0.box.205.631.747.230.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    attrs: {
      "id": "para.6.0.0.box.205.631.743.190.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\"That ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("all ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("one ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("consent ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("praise ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("new-born ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("gawds, ")]), _c('i', [_vm._v("Tho ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("they ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("are ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("made ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("moulded ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("things ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("past, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("And ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("give ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("dust ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("that ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("little ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("gilt ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("More ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("laud ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("than ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("gilt ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("o'er-dusted.\" ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em",
      "text-align": "right"
    },
    attrs: {
      "id": "para.6.0.1.box.262.828.690.33.q.40"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Troilus ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("And ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Cressida. ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Act ")]), _vm._v("3 : Sc. 8.")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA7"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.8.0.0.box.105.610.970.346.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-align": "center"
    },
    attrs: {
      "id": "para.8.0.0.box.337.610.510.36.q.70"
    }
  }, [_vm._v("TO FRANCES, MY WIFE")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%"
    },
    attrs: {
      "id": "para.8.0.1.box.105.710.970.246.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.5.0"
    }
  }), _vm._v("In memory of that bea"), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.9.0"
    }
  }), _vm._v("utiful summer in the "), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.10.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.11.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.12.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.13.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.14.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.15.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.16.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.17.0"
    }
  }), _vm._v("Ozark Hills, when, so"), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.18.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.19.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.20.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.21.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.22.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.23.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.24.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.0.0"
    }
  }), _vm._v(" often, we followed t"), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.9.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.10.0"
    }
  }), _vm._v("he old trail around t"), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.11.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.12.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.13.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.14.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.15.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.16.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.17.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.18.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.19.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.20.0"
    }
  }), _vm._v("he rim of Mutton Holl"), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.21.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.22.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.23.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.24.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.3.0"
    }
  }), _vm._v("ow—the trail th"), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.9.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.10.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.11.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.12.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.13.0"
    }
  }), _vm._v("at is nobody knows ho"), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.14.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.15.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.16.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.17.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.18.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.19.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.20.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.21.0"
    }
  }), _vm._v("w old — and fro"), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.22.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.23.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.24.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.25.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.26.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0"
    }
  }), _vm._v("m Sammy's lookout"), _c('a', {
    attrs: {
      "id": "GBS.PA12"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.0.0"
    }
  }), _vm._v(" watched the day go over the western ridges.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.0.0.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PA9"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PA10"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PA11"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.0.0.0.3"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 12",
      "src": "data/content-0006.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.0.0.0.4"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.0.0.0.5"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19b64423","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0007.vue
// module id = 54
// module chunks = 0